import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Service
import { CostharegionEditService } from '../../service/costharegion-edit/costharegion-edit.service';

@Component({
	selector: 'app-costharegion-edit',
	templateUrl: './costharegion-edit.component.html',
	providers: [
		CostharegionEditService,
		HttpModule
	]
})
export class CostharegionEditComponent implements OnInit {

	public permissoes: any[] = [];
	public costForm: FormGroup;
	private sub: any;
	public guid: string;
	private token = "";
	public nomeEstado: string;
	public nomeCidade: string;
	public statusCost: string;

	constructor(private fb: FormBuilder, private router: Router, private costharegionEditService: CostharegionEditService, private route: ActivatedRoute, private flashMessagesService: FlashMessagesService) {
		this.token = localStorage.getItem('yara.token');
		this.costForm = this.fb.group({
			'ID':'',
			'EstadoID':['', Validators.compose([Validators.required])],
			'CidadeID': ['', Validators.compose([Validators.required])],
			'ValorHaCultivavel': [null, Validators.compose([Validators.required])],
			'ValorHaNaoCultivavel': [null, Validators.compose([Validators.required])],
			'ModuloRural': [null, Validators.compose([Validators.required])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.guid = params['guid'];
			this.costharegionEditService.getCost(this.token, this.guid).subscribe(result => {
				var updateCost = result.Result;
				console.log(updateCost);
				this.costForm.setValue({
					ID: updateCost.ID,
					EstadoID: updateCost.Cidade.EstadoID,
					CidadeID: updateCost.CidadeID,
					ValorHaCultivavel: updateCost.ValorHaCultivavel,
					ValorHaNaoCultivavel: updateCost.ValorHaNaoCultivavel,
					ModuloRural: updateCost.ModuloRural,
					Ativo: updateCost.Ativo
				});
				this.nomeEstado = updateCost.Cidade.Estado.Nome;
				this.nomeCidade = updateCost.Cidade.Nome;
			}, error => {
				console.log(error);

			});
		});
	}

	saveEditCost(value: any) {

		this.costharegionEditService.editCost(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Custo do Ha por Região editado com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/custo-regiao');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/custo-regiao');
	}

}



// WEBPACK FOOTER //
// ./src/app/costharegion/component/costharegion-edit/costharegion-edit.component.ts